import { LanguageToggle, RenderProfileItem, RewardMenu } from './elements';
import { Avatar, Box, Button, FlexWrapper, FontIcon, MenuList, ProfileItem, Text, Separator } from '@intigral/shared';
import h from '../../../helpers/common';
import { __ } from '../../../translations';
import { MenuItem } from '@intigral/shared/components/MenuList';
import { Link } from 'react-router-dom';
import { KIDSMODE } from '../../../config/constants';
import { getProfileAvatar } from '../utils/headerUtils';
import user from '../../../helpers/user';
import { iHeaderMenuItemprops } from '../types/iHeaderMenu';
import { useHeaderMenuActions } from '../hooks/useHeaderMenuActions';
import { getUserInfo } from '../../../utils/user';
import { getFreeTrailCtaUrl, isGuestUser, redirectGuestToSignIn } from '../../../config/guestMode';

export const HeadermenuItem: React.FC<iHeaderMenuItemprops> = ({ setClickedProfile }) => {
    const isGuest = isGuestUser(getUserInfo());
    const {
        isMobile,
        selectedProfile,
        avatarData,
        profileList,
        selectProfileUrl,
        accountUrl,
        profileSettingUrl,
        kidExitUrl,
        language,
        handleLogOutUser,
        handleManage,
        handleKidExit,
    } = useHeaderMenuActions();

    return (
        <>
            {!isMobile && (
                <>
                    <LanguageToggle />
                    {!isGuest && (
                        <FlexWrapper direction="row" gap="4x" className="frame">
                            <MenuList
                                align="end"
                                triggerTitle={
                                    <Avatar
                                        border={!selectedProfile?.kidsMode}
                                        image={getProfileAvatar(selectedProfile, avatarData)}
                                        name={selectedProfile?.profileName}
                                        variant="header"
                                    />
                                }
                                variant="drop"
                                width="fit-content"
                            >
                                {profileList?.profiles?.map((profile, index) => {
                                    return (
                                        <RenderProfileItem
                                            key={profile?.profileGuid ?? profile?.profileId ?? index}
                                            index={index}
                                            profile={profile}
                                            selectedProfile={selectedProfile}
                                            avatarData={avatarData}
                                            setClickedProfile={setClickedProfile}
                                        />
                                    );
                                })}
                                <MenuItem
                                    variant="link"
                                    href={selectProfileUrl}
                                    linkAs={Link}
                                    linkProps={{ to: selectProfileUrl }}
                                    data-test-id="profile-menu-manage-profiles"
                                >
                                    <FontIcon md="smaller" name="switcher" size="smaller" />
                                    {__('manage_profiles_menu_link')}
                                </MenuItem>
                                {user?.getProfileMode() === KIDSMODE.KID && <RewardMenu />}
                                {user?.getProfileMode() !== KIDSMODE.KID && (
                                    <>
                                        <MenuItem divider />
                                        <MenuItem
                                            variant="link"
                                            href={accountUrl}
                                            linkProps={{ to: accountUrl }}
                                            data-test-id="profile-menu-my-account"
                                        >
                                            <FontIcon md="smaller" name="user" size="smaller" />
                                            {__('profile_my_account')}
                                        </MenuItem>
                                        <MenuItem
                                            variant="link"
                                            href={profileSettingUrl}
                                            linkAs={Link}
                                            linkProps={{ to: profileSettingUrl }}
                                            data-test-id="profile-menu-settings"
                                        >
                                            <FontIcon md="smaller" name="settings" size="smaller" />
                                            {__('profile_settings')}
                                        </MenuItem>
                                        <RewardMenu />
                                        <MenuItem divider />
                                        <MenuItem
                                            variant="link"
                                            onClick={handleLogOutUser}
                                            data-test-id="profile-menu-logout"
                                        >
                                            <FontIcon md="smaller" name="exit" size="smaller" />
                                            {__('settings_logout')}
                                        </MenuItem>
                                    </>
                                )}
                            </MenuList>
                        </FlexWrapper>
                    )}
                </>
            )}
            {isMobile && isGuest && (
                <>
                    <Separator className="pc-hidden" margin={'0'} theme={'bg'} />
                    <Button
                        compact
                        type="button"
                        onClick={() => {
                            const href = getFreeTrailCtaUrl();
                            if (href) {
                                window.location.assign(href);
                            }
                        }}
                    >
                        {__('header_guest_start_free_trial')}
                    </Button>
                    <Button
                        compact
                        type="button"
                        onClick={() => {
                            redirectGuestToSignIn();
                        }}
                        secondary
                    >
                        {__('settings_login')}
                    </Button>
                </>
            )}
            {isMobile && !isGuest && (
                <>
                    <FlexWrapper direction="column" gap="2x">
                        <ProfileItem
                            avatar={
                                <Avatar
                                    border
                                    color="rgb(165, 78, 225)"
                                    image={getProfileAvatar(selectedProfile, avatarData)}
                                    name={selectedProfile?.profileName}
                                    currentRestriction={
                                        selectedProfile?.newParentalControl || selectedProfile?.parentalControl
                                    }
                                    variant="inline"
                                    width={'5x'}
                                />
                            }
                            cta="Manage"
                            onClick={handleManage}
                            active
                        />
                    </FlexWrapper>
                </>
            )}
            {selectedProfile?.kidsMode && !h.isParentalPinScreen() && (
                <>
                    <Link to={kidExitUrl} onClick={handleKidExit} style={{ display: 'block' }}>
                        <Box
                            theme="light"
                            paddingTop={{ default: '2x', md: '1x' }}
                            paddingBottom={{ default: '2x', md: '1x' }}
                            paddingStart="3x"
                            paddingEnd="2x"
                        >
                            <FlexWrapper flexDirection="row" gap="2x" alignItems="center">
                                <Text as="span" fontWeight="medium">
                                    {language === 'en' ? __('settings_exit') : __('settings_exit')}
                                </Text>
                                <FontIcon name="exit" />
                            </FlexWrapper>
                        </Box>
                    </Link>
                </>
            )}
        </>
    );
};
